import {HttpClient, HttpParams} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AiAgentModel} from "../../models/ai-agent.model";

@Injectable({providedIn: 'root'})
export class AiAgentsHttpService {

  private base_url = `/aiAgent`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getAiAgents(params?: { limit?: number, cursor?: string, active?: boolean }): Observable<{ cursor: string, list: AiAgentModel[] }> {
    return this.http
      .get<{ cursor: string, list: AiAgentModel[] }>(this.base_url, {params});
  }

  createAiAgent(aiAgent: AiAgentModel): Observable<AiAgentModel> {
    return this.http
      .put<AiAgentModel>(this.base_url, aiAgent);
  }

  updateAiAgent(aiAgent: AiAgentModel): Observable<AiAgentModel> {
    return this.http
      .post<AiAgentModel>(this.base_url + `/${aiAgent.id}`, aiAgent);
  }

  deleteAiAgent(aiAgentId: string): Observable<AiAgentModel> {
    return this.http
      .delete<AiAgentModel>(this.base_url + `/${aiAgentId}`);
  }
}
